import * as React from 'react';
import { PresetType } from '../../store/types';
import { FixedDateRangeNavigatorContainer } from './FixedDateRangeNavigatorContainer';

export interface PresetNavigatorProps {
  preset: PresetType;
}
export const PresetNavigator: React.SFC<PresetNavigatorProps> = (props: PresetNavigatorProps) => {
  return props.preset !== PresetType.Custom ? <FixedDateRangeNavigatorContainer /> : null;
};



// WEBPACK FOOTER //
// ./src/components/navbar/PresetNavigator.tsx